export const resetPasswordMutation = /* GraphQL */ `
  mutation resetPassword($resetPasswordToken: String!, $newPassword: String!) {
    webPassword {
      resetPassword(input: { resetPasswordToken: $resetPasswordToken, newPassword: $newPassword }) {
        _empty
      }
    }
  }
`;

export const userSessionQuery = /* GraphQL */ `
  query UserSession {
    web {
      userSession {
        human {
          token
          customer_uuid
          email
          first_name
          full_name
          opendoor_internal_access
          primary_phone
          impersonated
        }
      }
    }
  }
`;

export const validateResetPasswordTokenQuery = /* GraphQL */ `
  query validateResetPasswordToken($resetPasswordToken: String!) {
    webPassword {
      validateResetPasswordToken(input: { resetPasswordToken: $resetPasswordToken }) {
        valid
      }
    }
  }
`;
